<h1 data-cy="tdo-icon-picker-header">Icon Selector</h1>

<div data-cy="tdo-icon-picker-main-container">


<div *ngFor="let f of zdataSource; let folderIndex = index" [attr.data-cy]="'tdo-icon-picker-folder-' + folderIndex">
  <div style="height: 40px; width: 100%; background-color: beige;" [attr.data-cy]="'tdo-icon-picker-folder-name-container-' + folderIndex">
  {{f.folderName}}
  </div>
    <div *ngFor="let ff of f.iconFolders; let subFolderIndex = index" [attr.data-cy]="'tdo-icon-picker-subfolder-' + folderIndex + '-' + subFolderIndex">
        {{ff.folderName}}

        <mat-grid-list cols="10" rowHeight="40px" [attr.data-cy]="'tdo-icon-picker-grid-' + folderIndex + '-' + subFolderIndex">
          <mat-grid-tile *ngFor="let i of ff.icons; let iconIndex = index" [attr.data-cy]="'tdo-icon-picker-icon-tile-' + folderIndex + '-' + subFolderIndex + '-' + iconIndex">
            <img [src]="'/assets'+ i.iconPath" style="width: 32px; height: 32px;cursor: pointer;" [matTooltip]="i.iconName" (click)="onImageClick(i)" mat-dialog-close [attr.data-cy]="'tdo-icon-picker-icon-image-' + folderIndex + '-' + subFolderIndex + '-' + iconIndex"/>
          </mat-grid-tile>

        </mat-grid-list>
    </div>
</div>

</div>